import React, { useState } from "react";
import TableSkeleton from "../../common/table/TableSkeleton";
import TableHeader from "../../common/table/TableHeader";
import ViewIcon from "../../../assets/icon/ViewIcon";
import ReactPaginate from "react-paginate";
import ButtonWithProgress from "../../common/button/ButtonWithProgress";
import { getColor, getName, getTextColor } from "../../../utiles/helpers";
import useToggle from "../../hooks/useToggle";
import ViewStore from "./ViewStore";
import { getData } from "../../../utiles/CookieUtile";
import { getDateFormatted, getToIso } from "../../../utiles/DateUtils";
import AddButton from "../../common/button/AddButton";
import AddStores from "./AddStore/AddStores";

const AllStoreTable = ({
  itemsPerPage,
  fetchAllStoreData,
  isbtnLoading,
  data = {},
  // setSuggestions,
  handleSelectSuggestion,
  searchRef,
  loading,
  // suggestions,
  setSearchTerm,
  handleSearch,
  searchTerm,
}) => {
  const headers = [
    { title: "S.No", width: "6rem" },
    { title: "Create At", width: "6rem" },
    { title: "Store Type", width: "" },
    { title: "Title ", width: "" },
    { title: "Phone ", width: "" },
    { title: "Email ", width: "" },
    { title: " Status ", width: "" },
    { title: "Action", width: "6rem" },
  ];

  const currentPageData = data?.results || [];
  const TimeZone = getData("TimeZone");
  const StoreModel = {
    viewStore: useToggle(),
    addStore: useToggle(),
  };

  const [isHide, setHide] = useState(true);
  const pageCount = data.totalpages;
  const [isViewata, setViewData] = useState([]);

  const handlePageChange = ({ selected }) => {
    fetchAllStoreData(selected + 1);
  };

  const handleView = (data) => {
    StoreModel.viewStore.handleOpen();
    setViewData(data);
  };

  return (
    <>
      <div className="row g-2">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 py-2">
                <div className="col-12 col-sm-6 suggestions-container ">
                  <div className="input-group mb-0">
                    <input
                      type="text"
                      className="form-control"
                      name="code"
                      placeholder="Search  by title,store type..."
                      autoComplete="off"
                      ref={searchRef}
                      value={searchTerm}
                      onChange={(e) => {
                        const value = e.target.value;
                        setSearchTerm(value);
                        handleSelectSuggestion(value);
                        setHide(true);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSearch(searchTerm);
                        }
                      }}
                    />
                    {isbtnLoading ? (
                      <ButtonWithProgress buttonClass="btn btn-primary pull-right" />
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary text-right"
                        disabled={!searchTerm.trim()}
                        onClick={() => handleSearch(searchTerm)}
                      >
                        <i className="bx bx-search"></i> Search
                      </button>
                    )}
                  </div>

                  {/* {isHide &&
                    searchTerm &&
                    suggestions &&
                    suggestions.length === 0 && (
                      <ul className="suggestions-list">
                        <li className="suggestion-item text-muted">
                          No store data was found
                        </li>
                      </ul>
                    )} */}

                  {/* {suggestions.length > 0 && (
                    <ul className="suggestions-list">
                      {suggestions.map((store, index) => (
                        <li
                          key={store._id || index}
                          onMouseDown={() => {
                            setSearchTerm(store?.stype || store?.title);
                            setSuggestions([]);
                            setHide(false);
                            handleSearch(store?.stype || store?.title);
                          }}
                          className="suggestion-item"
                        >
                          {store?.title} -{" "}
                          <span className="badge bg-label-warm rounded-pill">
                            {store?.stype}
                          </span>
                          {store?.email && (
                            <>
                              {" "}
                              -{" "}
                              <span className="badge bg-label-blue rounded-pill">
                                {store?.email}
                              </span>
                            </>
                          )}
                        </li>
                      ))}
                    </ul>
                  )} */}
                </div>
                <div className="col-12 col-md-auto ms-md-auto">
                  <AddButton
                    label="Add Store "
                    iconClass="bx bx-plus"
                    onClick={StoreModel.addStore.handleOpen}
                    buttonClass="btn btn-primary pull-right"
                  />
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive custom-scroll-container">
                <table className="table align-middle mb-0">
                  <TableHeader headers={headers} />
                  <tbody>
                    {loading ? (
                      <TableSkeleton
                        rows={5}
                        columns={[80, 80, 150, 150, 150, 150, 150]}
                      />
                    ) : currentPageData.length > 0 ? (
                      currentPageData.map((user, index) => (
                        <tr key={`${user._id}-${index}`} onClick={() => handleView(user)}>
                          <td className="text-center">
                            {" "}
                            {(data.currentpage - 1) * itemsPerPage + index + 1}
                          </td>
                          <td className="text-center">
                            {" "}
                            {user?.createdAt
                              ? `${
                                  getDateFormatted(
                                    getToIso(user.createdAt, "ISO", TimeZone)
                                  ).date
                                } at ${getDateFormatted(
                                  getToIso(user.createdAt, "ISO", TimeZone)
                                ).time.toUpperCase()}`
                              : ""}
                          </td>
                          <td className="text-center">
                            <span
                              className={`badge rounded-pill ${
                                user?.stype
                                  ? getColor(user?.stype.toLowerCase())
                                  : ""
                              }`}
                            >
                              {user?.stype || "-"}
                            </span>
                          </td>
                          <td
                            className={`text-center ${getTextColor(
                              user?.stype
                            )}`}
                          >
                            {user?.title || "-"}
                          </td>
                          
                          <td
                            className={`text-center ${getTextColor(
                              user?.stype
                            )}`}
                          >
                            +91 {user?.phone || "-"}
                          </td>
                          <td
                            className={`text-center ${getTextColor(
                              user?.stype
                            )}`}
                          >
                            {user?.email || "-"}
                          </td>

                          <td className="text-center">
                            <span
                              className={`badge rounded-pill ${getColor(
                                user?.status
                              )}`}
                            >
                              {getName(user?.status)}
                            </span>
                          </td>

                          <td>
                            <div className="d-block order-actions text-center">
                              <ViewIcon onView={() => handleView(user)} />
                            </div>
                          </td>
                          {/* )} */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No Data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                  {data?.results?.length > 0 && (
                    <tfoot>
                      <tr>
                        <td colSpan="8">
                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center  ps-4 pe-4 gap-3">
                            <span className="text-secondary">
                              {data?.results?.length > 0
                                ? `Showing `
                                : "No entries available"}

                              {data?.results?.length > 0 && (
                                <>
                                  <span className="fw-bold text-secondary">
                                    {(data.currentpage - 1) * itemsPerPage + 1}
                                  </span>{" "}
                                  to
                                  <span className="fw-bold text-secondary">
                                    {" "}
                                    {Math.min(
                                      data.currentpage * itemsPerPage,
                                      data.totalitems
                                    )}
                                  </span>{" "}
                                  of
                                  <span className="fw-bold text-dark">
                                    {" "}
                                    {data.totalitems}
                                  </span>{" "}
                                  entries
                                </>
                              )}
                            </span>

                            <ReactPaginate
                              previousLabel={"← Prev"}
                              nextLabel={"Next →"}
                              breakLabel={"..."}
                              pageCount={pageCount}
                              onPageChange={handlePageChange}
                              containerClassName={"pagination"}
                              activeClassName={"active"}
                              pageClassName={"page-item"}
                              pageLinkClassName={"page-link"}
                              previousClassName={"page-item"}
                              previousLinkClassName={"page-link"}
                              nextClassName={"page-item"}
                              nextLinkClassName={"page-link"}
                              disabledClassName={"disabled"}
                              breakClassName={"page-item"}
                              breakLinkClassName={"page-link"}
                            />
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>
            </div>
          </div>
          {StoreModel.addStore.isOpen && (
            <AddStores onClose={StoreModel.addStore.handleClose} />
          )}
          {StoreModel.viewStore.isOpen && (
            <ViewStore
              data={isViewata}
              onClose={StoreModel.viewStore.handleClose}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AllStoreTable;
